import {
  AnalyticsClient,
  analyticsClient,
} from "./analyticsClient/analyticsClient";
import { analyticsClientStub } from "./analyticsClient/stub";
import { CompetitionsClient } from "./competitionsClient/competitionsClient";
import { competitionsClientStub } from "./competitionsClient/stub";

export interface LegacyClients {
  analyticsClient: AnalyticsClient;
  competitionsClient: CompetitionsClient;
}

export const legacyClients: LegacyClients = {
  analyticsClient,
  // TODO(mbooth): Migrate to Command Handler. Currently using adhocClient.
  competitionsClient: {} as any,
};

export const legacyClientsStub: LegacyClients = {
  analyticsClient: analyticsClientStub,
  competitionsClient: competitionsClientStub,
};
